import { Root } from './Root'

export const Modal = {
  Root,
}
